module.exports = __webpack_public_path__ + "static/img/nobelisk-detonator_256.3c30d5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nobelisk-detonator_256.png
// module id = eCpx
// module chunks = 0